if (!customElements.get('custom-pagination')) {
  class CustomPagination extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.section;
      this.loadMoreButton = this.querySelector('.btn--load-more');
      this.productList = document.querySelector(`ul[data-id="${this.sectionId}"]`);
      this.paginationType = this.getAttribute('data-type');
      this.countItem = parseInt(this.productList.getAttribute('data-products-count'));
      this.currentPage = 2;
    }

    connectedCallback() {
      if (this.paginationType === 'load-more-button') {
        this.loadMoreButton.addEventListener('click', () => this.loadNextPage());
      }
      if (this.paginationType === 'infinite-scroll') {
        this.scrollObserver = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting) this.loadNextPage();
        }, { threshold: [0, 1] });
        this.scrollObserver.observe(this);
      }
    }

    buildUrlWithPageNumber(search, key) {
      const newParam = `${key}=${this.currentPage}`;
      let params = search ? search.replace(new RegExp(`([?&])${key}[^&]*`), `$1${newParam}`) : `?${newParam}`;
      if (!search || params === search) params += `&${newParam}`;
      return params;
    }

    loadNextPage() {
      if (this.hasAttribute('loading')) return;
      this.setAttribute('loading', true);
      this.showLoadingSpinner();
      
      const url = `${document.location.pathname}${this.buildUrlWithPageNumber(document.location.search, 'page')}`;
      this.currentPage++;

      fetch(url)
        .then(response => response.text())
        .then(html => this.renderFetchedProducts(html))
        .catch(error => console.error('Error fetching products:', error))
        .finally(() => {
          this.hideLoadingSpinner();
          this.removeAttribute('loading');
        });
        
    }

    renderFetchedProducts(html) {
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(html, 'text/html');
      const newProductGrid = newDocument.getElementById('product-grid');
      if (!newProductGrid || !newProductGrid.children.length) {
        this.finalizePagination();
        return;
      }
      Array.from(newProductGrid.querySelectorAll('.grid__item')).forEach(product => this.productList.appendChild(product));
      if(this.productList.children.length >= this.countItem){
        this.finalizePagination();
        return;
      }
      
    }

    showLoadingSpinner() {
      if (this.loadMoreButton) {
        this.loadMoreButton.classList.add('loading');
        const spinner = this.loadMoreButton.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');
      }
    }

    hideLoadingSpinner() {
      if (this.loadMoreButton) {
        this.loadMoreButton.classList.remove('loading');
        const spinner = this.loadMoreButton.querySelector('.loading__spinner');
        if (spinner) spinner.classList.add('hidden');
      }
    }
    finalizePagination() {
      if (this.scrollObserver) this.scrollObserver.unobserve(this);
      if (this.loadMoreButton) this.loadMoreButton.classList.add('visually-hidden');
    }
  }

  customElements.define('custom-pagination', CustomPagination);
}
